import React from "react";
import { render } from "react-dom";
import { Redirect, Route, Switch, Router } from "react-router-dom";
import history from "./history";
import PathToRegexp, { compile } from "path-to-regexp";
import { I18nextProvider } from "react-i18next";

import i18n from "./i18n/config";

import "./bootstrap/dist/css/bootstrap.css";
import Home from "./components/pages/home";
import Conf from "./components/pages/conf";
import Comp from "./components/pages/comp";
import Comp2 from "./components/pages/comp2";
import About from "./components/pages/about";
import Faq from "./components/pages/faq";
import Personal from "./components/pages/personal";
import Privacy from "./components/pages/privacy";
import Terms from "./components/pages/terms";
import Ack from "./components/pages/ack";
import Sponsor from "./components/pages/sponsor";
import Gallery from "./components/pages/gallery";
import GalleryConf from "./components/pages/galleryConf";
import GalleryWork from "./components/pages/galleryWork";
import GalleryMeeting from "./components/pages/galleryMeeting";
import GalleryAward from "./components/pages/galleryAward";
import Award from "./components/pages/award";
import Lab from "./components/pages/lab";
import LabEvent from "./components/pages/labEvent";
import Header from "./components/layout/header";
const lang = i18n.language;

const generateLanguage = (locale, location) => {
  const ROUTE = "/:locale/:path*";
  const definePath = compile(ROUTE);
  const routeComponents = PathToRegexp(ROUTE).exec(location.pathname);

  let subPaths = null;
  if (routeComponents && routeComponents[2]) {
    subPaths = routeComponents[2].split("/");
  }
  return definePath({
    locale,
    path: subPaths,
  });
};

const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  window.location.reload();
};


let App = ({ match, location }) => {
  // console.log("location", location);
  // console.log("match", match);
  if (lang !== match.params.locale) {
    changeLanguage(match.params.locale);
  }
  return (
    <div>
      <Header
        en_to={generateLanguage("en", location)}
        en_onClick={() => changeLanguage("en")}
        tc_to={generateLanguage("tc", location)}
        tc_onClick={() => changeLanguage("tc")}
        sc_to={generateLanguage("sc", location)}
        sc_onClick={() => changeLanguage("sc")}
        match={match.url}
      />
      <Switch>
        <Route exact path={`${match.url}/home`}
          component={(props) => (
            <Home {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/conference`}
          component={(props) => (
            <Conf {...props} key={window.location.pathname} />
          )}
        />
        <Route
          path={`${match.url}/competition`}
          component={(props) => (
            <Comp {...props} key={window.location.pathname} />
          )}
        />
        <Route
          path={`${match.url}/competition2`}
          component={(props) => (
            <Comp2 {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/about`}
          component={(props) => (
            <About {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/faq`}
          component={(props) => (
            <Faq {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/personal`}
          component={(props) => (
            <Personal {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/privacy`}
          component={(props) => (
            <Privacy {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/terms`}
          component={(props) => (
            <Terms {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/acknowledgements`}
          component={(props) => (
            <Ack {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/sponsors`}
          component={(props) => (
            <Sponsor {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/gallery`}
          component={(props) => (
            <Gallery {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/gallery-conference`}
          component={(props) => (
            <GalleryConf {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/gallery-competition`}
          component={(props) => (
            <GalleryWork {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/gallery-innovations`}
          component={(props) => (
            <GalleryMeeting {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/gallery-awards`}
          component={(props) => (
            <GalleryAward {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/awardsceremony`}
          component={(props) => (
            <Award {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/E&MAILab/event`}
          component={(props) => (
            <LabEvent {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/E%26MAILab/event`}
          component={(props) => (
            <LabEvent {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/E&MAILab`}
          component={(props) => (
            <Lab {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/E%26MAILab`}
          component={(props) => (
            <Lab {...props} key={window.location.pathname} />
          )}
        />
        <Route path={`${match.url}/E%26MAILab/about`}
          component={(props) => (
            <Lab {...props} key={window.location.pathname} />
          )}
        />

        <Route path={`${match.url}/E&MAILab/about`}
          component={(props) => (
            <Lab {...props} key={window.location.pathname} />
          )}
        />
        <Route
          path="/21/video"
          render={() => {
            window.location.href = "/21/video.mp4";
            return null;
          }}
        />
        <Route
          path="/21/booklet"
          render={() => {
            window.location.href = "/21/booklet.pdf";
            return null;
          }}
        />

        <Route path="*" 
        render={() => {
          window.location.replace("/en/home"); // Mimics a 302 redirect
          return null;
        }} />
      </Switch>
    </div>
  );
};

render(
  <I18nextProvider i18n={i18n}>
    <Router history={history}>
      <Switch>
        <Route path="/:locale" component={App} />
        <Redirect to="/en/home" />
      </Switch>
    </Router>
  </I18nextProvider>,
  document.getElementById('root') // Render into the #root container
);



// WEBPACK FOOTER //
// ./src/index.js